var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 674,
    height: 402,
    viewBox: "0 0 674 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M561.49 31.409C561.49 31.409 544.749 31.4594 550.274 11.1252C571.918 16.8175 561.49 31.409 561.49 31.409Z",
    fill: "#C7D0D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M567.367 39.0156C567.367 39.0156 561.137 29.5789 574.654 25.1628C579.456 39.4857 567.367 39.0156 567.367 39.0156Z",
    fill: "#C7D0D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M574.352 50.2656C574.352 50.2656 569.147 40.2245 583.05 37.2524C586.324 51.9951 574.352 50.2656 574.352 50.2656Z",
    fill: "#C7D0D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M577.593 61.3476C577.593 61.3476 575.947 50.1647 590.069 51.8942C588.339 66.9223 577.593 61.3476 577.593 61.3476Z",
    fill: "#C7D0D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M564.277 39.6702C564.277 39.6702 557.762 48.9054 548.728 37.924C560.314 28.2354 564.277 39.6702 564.277 39.6702Z",
    fill: "#C7D0D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M569.718 52.5158C569.718 52.5158 563.203 61.7509 554.169 50.7695C565.755 41.0642 569.718 52.5158 569.718 52.5158Z",
    fill: "#C7D0D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M584.107 88.0626C584.107 88.0626 580.245 77.4338 594.434 76.292C595.744 91.3537 584.107 88.0626 584.107 88.0626Z",
    fill: "#C7D0D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M578.567 87.8278C578.567 87.8278 572.052 97.0629 563.018 86.0815C574.604 76.3762 578.567 87.8278 578.567 87.8278Z",
    fill: "#C7D0D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M586.206 100.387C586.206 100.387 582.344 89.7583 596.533 88.6165C597.859 103.678 586.206 100.387 586.206 100.387Z",
    fill: "#C7D0D9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M580.682 100.152C580.682 100.152 574.167 109.387 565.134 98.4056C576.719 88.7171 580.682 100.152 580.682 100.152Z",
    fill: "#C7D0D9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M573.412 62.2711C573.412 62.2711 569.701 72.9503 557.981 64.8906C566.443 52.3643 573.412 62.2711 573.412 62.2711Z",
    fill: "#C7D0D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M580.481 73.4208C580.481 73.4208 578.835 62.2379 592.957 63.9674C591.244 78.9787 580.481 73.4208 580.481 73.4208Z",
    fill: "#C7D0D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M576.299 74.3439C576.299 74.3439 572.588 85.0231 560.868 76.9633C569.348 64.4371 576.299 74.3439 576.299 74.3439Z",
    fill: "#C7D0D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M586.761 125.742C586.761 125.742 584.813 114.609 598.968 115.936C597.658 130.998 586.761 125.742 586.761 125.742Z",
    fill: "#C7D0D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M581.354 124.533C581.354 124.533 573.328 132.509 566.343 120.117C579.423 112.578 581.354 124.533 581.354 124.533Z",
    fill: "#C7D0D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M586.694 138.252C586.694 138.252 584.729 127.119 598.901 128.445C597.608 143.507 586.694 138.252 586.694 138.252Z",
    fill: "#C7D0D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M581.287 137.042C581.287 137.042 573.261 145.018 566.276 132.626C579.373 125.104 581.287 137.042 581.287 137.042Z",
    fill: "#C7D0D9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M585.736 110.697C585.736 110.697 586.055 99.3965 599.656 103.544C595.358 118.035 585.736 110.697 585.736 110.697Z",
    fill: "#C7D0D9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M581.454 110.865C581.454 110.865 575.947 120.738 565.805 110.764C576.316 99.9171 581.454 110.865 581.454 110.865Z",
    fill: "#C7D0D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M561.792 32.1646C561.792 32.1646 624.39 124.667 537.243 261.163",
    stroke: "#4D53E0",
    strokeWidth: 0.6182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M226.187 51.2057L206.474 24.1215L210.705 14.6009L180.095 1L175.864 10.5206L142.55 14.0468L136.421 5.63437L109.337 25.3304L115.466 33.7596L101.865 64.37L91.5215 65.4614L95.0476 98.7751L105.408 97.6837L125.121 124.751L120.889 134.272L151.5 147.873L155.731 138.352L189.045 134.826L195.174 143.255L222.241 123.542L216.112 115.13L229.713 84.5194L240.073 83.4112L236.547 50.1143L226.187 51.2057ZM190.271 85.3086C184.259 98.8255 168.425 104.921 154.908 98.9095C141.391 92.8982 135.296 77.0641 141.307 63.5472C147.319 50.0303 163.153 43.9351 176.67 49.9464C190.187 55.9576 196.282 71.7917 190.271 85.3086Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M122.199 147.722L113.064 133.584L115.449 128.932L100.471 121.259L98.0867 125.91L81.2787 126.75L78.441 122.35L64.3028 131.485L67.1405 135.884L59.4669 150.862L54.2449 151.13L55.0844 167.938L60.3065 167.67L69.4409 181.808L67.0566 186.459L82.0343 194.133L84.4187 189.481L101.227 188.642L104.064 193.041L118.203 183.907L115.365 179.507L123.038 164.53L128.26 164.261L127.421 147.453L122.199 147.722ZM103.225 163.841C99.833 170.457 91.706 173.076 85.0903 169.685C78.4746 166.293 75.8551 158.166 79.247 151.55C82.6388 144.934 90.7489 142.315 97.3815 145.707C104.014 149.099 106.617 157.209 103.225 163.841Z",
    fill: "#C7D0D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M652.549 162.733C637.118 168.66 614.483 168.123 612.216 191.664C610.638 207.918 621.603 222.862 604.039 233.709C597.071 238.008 589.33 239.25 585.149 247.025C581.522 253.775 582.429 262.12 583.252 269.424C583.957 275.704 586.929 283.462 586.123 289.809C584.796 300.152 576.3 301.932 568.761 307.255C561.591 312.326 555.462 319.361 554.203 328.445C552.54 340.451 561.339 348.83 562.817 359.761C562.817 359.761 576.518 401.319 615.826 376.132C625.112 370.171 635.203 365.99 640.593 355.126C644.674 346.916 643.599 337.647 640.526 329.419C637.302 320.772 631.274 314.509 636.026 305.223C638.931 299.531 645.765 294.796 649.896 290.01C654.698 284.452 660.138 278.072 660.961 270.448C661.901 261.683 656.209 256.277 652.885 248.805C644.489 229.948 661.985 223.769 669.844 209.48C681.245 188.742 662.254 176.435 652.851 162.834L652.549 162.733Z",
    fill: "#4D53E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M641.047 200.53L581.32 393.88",
    stroke: "white",
    strokeWidth: 0.6182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M604.778 250.752L616.23 280.842",
    stroke: "white",
    strokeWidth: 0.6182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M594.904 349.888L622.055 339.88",
    stroke: "white",
    strokeWidth: 0.6182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M623.718 256.612L643.481 243.633",
    stroke: "white",
    strokeWidth: 0.6182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M129.554 390.959C127.371 389.968 99.6317 377.039 70.6837 348.023C43.0957 320.368 8.75773 272.026 1.58789 198.649C66.2844 217.354 105.106 267.375 126.313 306.129C147.94 345.639 156.1 381.74 157.108 386.442L129.554 390.959Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1586 199.355C30.2503 207.599 55.8065 222.409 78.0884 243.381C96.2565 260.458 112.309 281.648 125.826 306.348C146.764 344.598 155.076 379.642 156.47 386.039L129.604 390.438C126.615 389.062 99.43 376.149 71.0529 347.705C53.4725 330.074 38.881 310.042 27.7148 288.146C13.9796 261.18 5.38251 231.325 2.1586 199.355ZM1 197.961C14.6177 341.139 129.486 391.496 129.486 391.496L157.712 386.879C157.712 386.862 127.421 233.944 1 197.961Z",
    fill: "#4D53E0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5396 267.997L71.6408 291.337",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6311 316.457L91.8569 256.042",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M106.734 274.344L104.971 335.397",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1 197.961L146.093 389.767",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M641.047 395.744H661.13",
    stroke: "#4D53E0",
    strokeWidth: 0.6182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4949 395.744H89.5065",
    stroke: "#4D53E0",
    strokeWidth: 0.6182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M245.01 332.324H137.529V361.793H245.01V332.324Z",
    fill: "#C7D0D9",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M219.017 395.744H116.288C104.165 395.744 94.342 385.921 94.342 373.798C94.342 361.675 104.165 351.852 116.288 351.852L219.017 362.212V395.744Z",
    fill: "#C7D0D9",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M137.697 401L157.376 387.063V370.91H137.697V401Z",
    fill: "#4D53E0",
    stroke: "white",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M156.688 395.744H259.416C271.539 395.744 281.362 385.921 281.362 373.798C281.362 361.675 271.539 351.852 259.416 351.852L156.688 362.212V395.744Z",
    fill: "#C7D0D9",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M171.901 155.026C171.901 155.026 162.817 139.729 171.901 134.037C180.985 128.328 207.515 122.367 207.515 122.367L204.392 149.686L171.901 155.026Z",
    fill: "#4D53E0",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M126.549 342.785H249.159V282.135H126.549L126.549 342.785Z",
    fill: "#4D53E0",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M264.185 264.672C264.185 223.819 231.862 189.817 191.025 188.843C190.186 188.827 189.346 188.81 188.49 188.81C127.051 188.81 107.674 233.458 104.769 241.165C98.2877 258.325 88.9518 307.003 141.575 309.085C194.199 311.167 200.932 310.899 200.932 310.899L264.185 304.686V264.672Z",
    fill: "#4D53E0",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M185.518 199.875C191.697 199.875 196.718 194.855 196.718 188.675V152.289H174.318V188.675C174.318 194.871 179.322 199.875 185.518 199.875Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M165.872 159.207C166.443 162.598 169.667 164.865 173.042 164.294C173.563 164.21 174.067 164.059 174.537 163.841C175.343 165.99 176.552 167.905 178.096 169.5C181.774 173.345 187.231 175.343 192.856 174.386C201.89 172.841 207.968 164.294 206.423 155.244C204.878 146.21 196.332 140.132 187.281 141.677C181.152 142.718 176.384 146.983 174.453 152.457C173.395 151.986 172.186 151.819 170.96 152.037C167.585 152.608 165.301 155.832 165.872 159.207Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M175.612 159.996C175.612 159.996 174.89 156.94 171.918 157.863",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M387.012 381.069H259.198C244.707 381.069 232.953 369.315 232.953 354.824V230.317C232.953 215.827 244.707 204.073 259.198 204.073H387.012C401.503 204.073 413.257 215.827 413.257 230.317V354.824C413.257 369.315 401.52 381.069 387.012 381.069Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M210.034 281.917L233.172 277.887L233.34 283.461L242.877 283.898L242.491 307.154L207.532 307.49L210.034 281.917Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M242.759 290.396L231.828 289.943",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M242.272 296.24L231.341 295.803",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M242.205 302.083L231.274 301.646",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M204.542 307.926C195.072 308.564 176.367 309.589 154.941 309.538L204.542 307.926Z",
    fill: "#4D53E0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M204.542 307.926C195.072 308.564 176.367 309.589 154.941 309.538",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M139.242 256.898C139.242 256.898 137.227 275.402 146.361 275.721C155.512 276.04 210.335 277.4 210.335 277.4",
    fill: "#4D53E0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M139.242 256.898C139.242 256.898 137.227 275.402 146.361 275.721C155.512 276.04 210.335 277.4 210.335 277.4",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M284.251 242.961H379.877",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M284.251 268.215H379.877",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M284.251 293.452H379.877",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M284.251 318.689H379.877",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M284.251 343.943H379.877",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M273.84 242.961C273.84 244.657 272.464 246.034 270.768 246.034C269.072 246.034 267.695 244.657 267.695 242.961C267.695 241.265 269.072 239.888 270.768 239.888C272.464 239.905 273.84 241.265 273.84 242.961Z",
    fill: "#FF5668"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M273.84 268.199C273.84 269.894 272.464 271.271 270.768 271.271C269.072 271.271 267.695 269.894 267.695 268.199C267.695 266.503 269.072 265.126 270.768 265.126C272.464 265.126 273.84 266.503 273.84 268.199Z",
    fill: "#FF5668"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M273.84 293.419C273.84 295.115 272.464 296.492 270.768 296.492C269.072 296.492 267.695 295.115 267.695 293.419C267.695 291.723 269.072 290.346 270.768 290.346C272.464 290.346 273.84 291.723 273.84 293.419Z",
    fill: "#FF5668"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M273.84 318.639C273.84 320.335 272.464 321.712 270.768 321.712C269.072 321.712 267.695 320.335 267.695 318.639C267.695 316.943 269.072 315.566 270.768 315.566C272.464 315.566 273.84 316.943 273.84 318.639Z",
    fill: "#FF5668"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M273.84 343.86C273.84 345.556 272.464 346.932 270.768 346.932C269.072 346.932 267.695 345.556 267.695 343.86C267.695 342.164 269.072 340.787 270.768 340.787C272.464 340.804 273.84 342.181 273.84 343.86Z",
    fill: "#FF5668"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M281.581 99.2622H244.036C239.452 99.2622 235.741 102.973 235.741 107.557V145.102C235.741 149.686 239.452 153.397 244.036 153.397H248.955V164.832L262.926 153.397H281.581C286.165 153.397 289.876 149.686 289.876 145.102V107.557C289.876 102.99 286.165 99.2622 281.581 99.2622Z",
    fill: "#C7D0D9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M634.247 398.918L614.551 384.998V368.828H634.247V398.918Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M570.44 353.313V395.745H483.126C465.546 395.745 451.29 381.489 451.29 363.909V291.371H503.208V353.313H570.44Z",
    fill: "#C7D0D9",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M495.4 291.371H547.319V353.313H614.551V395.745H527.236C509.656 395.745 495.4 381.489 495.4 363.909V320.184",
    fill: "#C7D0D9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M495.4 291.371H547.319V353.313H614.551V395.745H527.236C509.656 395.745 495.4 381.489 495.4 363.909V320.184",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M581.119 196.752C578.214 189.045 558.821 144.397 497.398 144.397C496.542 144.397 495.702 144.414 494.863 144.431C454.027 145.405 421.704 179.407 421.704 220.26V260.273H436.732V302.1H559.341V256.411C594.888 247.394 586.895 212.032 581.119 196.752Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M525.876 135.313L477.77 141.845V108.346C477.77 96.4413 492.395 86.7864 504.316 86.7864C516.221 86.7864 525.876 96.4413 525.876 108.346V135.313Z",
    fill: "#4D53E0",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M495.602 155.849C489.423 155.849 484.402 150.828 484.402 144.649V108.262H506.785V144.649C506.785 150.828 501.781 155.849 495.602 155.849Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M514.66 110.076C514.929 113.501 512.376 116.507 508.951 116.775C508.414 116.826 507.893 116.792 507.389 116.708C507.138 118.992 506.432 121.141 505.341 123.072C502.722 127.69 497.919 130.981 492.227 131.434C483.093 132.173 475.1 125.356 474.361 116.221C473.622 107.087 480.44 99.0943 489.574 98.3554C495.77 97.8517 501.445 100.824 504.669 105.643C505.593 104.921 506.718 104.467 507.96 104.367C511.386 104.098 514.391 106.65 514.66 110.076Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M470.784 109.69L504.669 105.643L499.145 88.516C498.977 87.794 498.053 87.3742 497.063 87.5925L485.242 90.1951C475.368 92.3612 468.769 100.555 470.516 108.498L470.784 109.69Z",
    fill: "#4D53E0",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M505.425 113.232C505.425 113.232 505.375 110.092 508.481 110.26",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M378.836 283.764H452.902C461.297 283.764 468.115 276.964 468.115 268.551V198.65C468.115 190.254 461.314 183.437 452.902 183.437H378.836C370.44 183.437 363.623 190.237 363.623 198.65V268.568C363.64 276.964 370.44 283.764 378.836 283.764Z",
    fill: "#FFC405",
    stroke: "#FFC405",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M490.598 243.969L468.132 246.236V251.122L458.762 253.019L462.389 273.891L496.996 268.837L490.598 243.969Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6071,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M503.594 269.173C511.939 268.518 521.796 267.913 551.886 262.473",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M548.545 207.028C548.545 207.028 553.38 224.995 544.397 226.724C535.414 228.454 494.662 235.993 494.662 235.993",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M459.887 258.392L470.617 256.277",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M461.197 263.699L471.943 261.583",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M461.986 268.333L472.716 266.217",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M527.236 395.744C509.656 395.744 495.4 381.489 495.4 363.908V320.184",
    stroke: "#4D53E0",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M415.877 238.344C424.696 238.344 431.846 231.195 431.846 222.375C431.846 213.556 424.696 206.407 415.877 206.407C407.058 206.407 399.909 213.556 399.909 222.375C399.909 231.195 407.058 238.344 415.877 238.344Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M437.505 259.988H394.234C394.234 248.033 403.922 238.361 415.861 238.361C427.799 238.361 437.505 248.049 437.505 259.988Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M337.865 395.744H450.299",
    stroke: "#4D53E0",
    strokeWidth: 0.6182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M466.553 21.3843H466.519C456.176 21.3843 447.797 29.5112 447.797 39.5188C447.797 42.6419 448.586 45.5804 450.03 48.1495L452.23 51.5749C453.959 54.2614 455.084 57.2503 455.571 60.3734L456.444 66.0825H466.536H476.644L477.769 59.7522C478.256 57.032 479.23 54.4126 480.674 52.0282L483.025 48.1327C484.452 45.5804 485.258 42.6587 485.275 39.5356C485.258 29.5784 476.846 21.4011 466.553 21.3843Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M473.135 40.0564H459.903L463.312 68.6014H469.726L473.135 40.0564Z",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M466.519 66.0996H456.428V75.1836H466.519H476.711V66.0996H466.519Z",
    fill: "#4D53E0",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M466.57 14.6513V4.47583",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M442.021 39.2H431.845",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M501.294 39.2H491.118",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M449.208 56.5623L442.021 63.7657",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M491.119 14.6514L483.932 21.838",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M449.208 21.838L442.021 14.6514",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M491.119 63.7657L483.932 56.5623",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M383.752 129.701C409.423 115.356 418.606 82.9168 404.262 57.2451C389.917 31.5733 357.478 22.3907 331.806 36.7351C306.134 51.0796 296.952 83.5191 311.296 109.191C325.641 134.863 358.08 144.045 383.752 129.701Z",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.22"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M355.362 143.373C355.362 143.373 357.243 181.338 318.757 199.808L355.362 143.373Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M355.362 143.373C355.362 143.373 357.243 181.338 318.757 199.808",
    stroke: "#4D53E0",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.22"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M383.621 70.8179V49.5602C383.621 48.5024 382.412 47.8979 381.556 48.536L342.919 71.8086H331.434C331.35 71.8086 331.249 71.8086 331.165 71.8086C326.094 71.9429 321.762 75.8888 321.527 80.9766C321.41 83.277 322.115 85.4262 323.357 87.1389C325.12 89.5401 327.958 91.1017 331.165 91.1017H340.552H342.919L381.556 114.357C382.412 114.996 383.621 114.391 383.621 113.333V92.0756",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M383.621 70.8179V49.5602C383.621 48.5024 382.412 47.8979 381.556 48.536L342.919 71.8086H331.434C331.35 71.8086 331.249 71.8086 331.165 71.8086C326.094 71.9429 321.762 75.8888 321.527 80.9766C321.41 83.277 322.115 85.4262 323.357 87.1389C325.12 89.5401 327.958 91.1017 331.165 91.1017H340.552H342.919L381.556 114.357C382.412 114.996 383.621 114.391 383.621 113.333V92.0756",
    stroke: "#4D53E0",
    strokeWidth: 0.6138,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M342.919 71.8083H333.734V91.1182H342.919V71.8083Z",
    fill: "#4D53E0",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M389.229 81.4469C389.229 85.863 386.996 89.7586 383.604 92.0758V70.8181C387.013 73.1353 389.229 77.0309 389.229 81.4469Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6138,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M331.165 91.1016H333.482L340.887 114.895C341.122 115.331 340.803 115.835 340.316 115.835H333.616C333.365 115.835 333.146 115.684 333.029 115.466L323.374 87.1221C325.12 89.54 327.958 91.1016 331.165 91.1016Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6138,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M255.974 125.876C255.974 127.824 254.396 129.385 252.465 129.385C250.534 129.385 248.956 127.807 248.956 125.876C248.956 123.945 250.534 122.367 252.465 122.367C254.396 122.367 255.974 123.928 255.974 125.876Z",
    fill: "#4D53E0",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M266.318 125.876C266.318 127.824 264.739 129.385 262.808 129.385C260.861 129.385 259.299 127.807 259.299 125.876C259.299 123.945 260.877 122.367 262.808 122.367C264.739 122.367 266.318 123.928 266.318 125.876Z",
    fill: "#4D53E0",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M276.662 125.876C276.662 127.824 275.083 129.385 273.152 129.385C271.221 129.385 269.643 127.807 269.643 125.876C269.643 123.945 271.221 122.367 273.152 122.367C275.083 122.367 276.662 123.928 276.662 125.876Z",
    fill: "#4D53E0",
    stroke: "#4D53E0",
    strokeWidth: 0.607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/errorImage.f2dac3afc1071173665b55c74a5ba088.svg";
export { ForwardRef as ReactComponent };